export default __webpack_public_path__ + "f7726897c5c65a62320d588d38c107f8.png";